
// // import React, { useState, useEffect } from "react";
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   Grid,
// //   Card,
// //   CardContent,
// //   Tabs,
// //   Tab,
// //   Chip,
// //   IconButton,
// //   Avatar,
// //   Divider,
// //   Badge,
// //   CircularProgress,
// //   Pagination,
// // } from "@mui/material";
// // import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// // import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
// // import PersonIcon from "@mui/icons-material/Person";
// // import InvestmentDetail from "./InvestmentDetail";
// // import ApplicationModal from "./ApplicationModal";
// // import { commonRunQuery } from "../../util/API/loans";
// // import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";

// // const MOCK_INVESTOR_PRODUCTS = [
// //   {
// //     id: 201,
// //     title: "Private Tech Equity",
// //     minEntry: "$10,000",
// //     status: "Pending Review",
// //     creator: "John Doe",
// //   },
// //   {
// //     id: 202,
// //     title: "Family Office Debt",
// //     minEntry: "$100,000",
// //     status: "Active",
// //     creator: "Jane Smith",
// //   },
// // ];

// // const CARDS_PER_PAGE = 6;

// // const decodeFileName = (name) => {
// //   if (!name) return "—";
// //   return name
// //     .replace(/&amp;#039;/g, "'")
// //     .replace(/&amp;#39;/g, "'")
// //     .replace(/&#039;/g, "'")
// //     .replace(/&#39;/g, "'")
// //     .replace(/&amp;/g, "&")
// //     .replace(/&lt;/g, "<")
// //     .replace(/&gt;/g, ">")
// //     .replace(/&quot;/g, '"');
// // };
// // const InvestmentMarketplace = ({ onBack, userRole }) => {
// //   const [tabValue, setTabValue] = useState(0);
// //   const [selectedProduct, setSelectedProduct] = useState(null);
// //   const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
// //   const [productToApply, setProductToApply] = useState(null);
// //   const [investmentsPlans, setInvestmentsPlans] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   // ── Pagination state ──
// //   const [currentPage, setCurrentPage] = useState(1);

// //   const user = JSON.parse(sessionStorage.getItem("user")).payload?.body;

// //   const handleOpenApply = (product) => {
// //     setProductToApply(product);
// //     setIsApplyModalOpen(true);
// //   };

// //   const handleCloseApply = () => {
// //     setIsApplyModalOpen(false);
// //     setProductToApply(null);
// //   };

// //   // Reset to page 1 whenever tab changes
// //   const handleTabChange = (e, val) => {
// //     setTabValue(val);
// //     setCurrentPage(1);
// //   };

// //   useEffect(() => {
// //     getInvestments();
// //   }, []);

// //   const isAdmin = userRole === "admin";
// //   const getInvestments = async () => {
// //     setLoading(true);
// //     console.log("Enter the function to get investments");
// //     try {
// //       const response = await commonRunQuery(359, "");
// //       console.log("First Response ????????????", response);

// //       const records = response?.data?.body?.record;

// //       if (records) {
// //         const recordsArray = Array.isArray(records) ? records : [records];
// //         const mapped = recordsArray.map((item) => {
// //           const fund = item.funds;
// //           return {
// //             id: fund.id,
// //             title: decodeFileName(fund.name),
// //             minEntry: `$${Number(fund.minimum_ticket_size).toLocaleString()}`,
// //             status: "Active",
// //             creator: fund.created_by_role,
// //             description: fund.description,
// //             totalFundSize: `$${Number(fund.total_fund_size).toLocaleString()}`,
// //             targetMultiple: fund.target_multiple,
// //             targetYearlyReturn: `${fund.target_yearly_return}%`,
// //             tvpi: fund.tvpi,
// //             dpi: fund.dpi,
// //             rvpi: fund.rvpi,
// //             videoUrl: fund.associated_video_url,
// //             startDate: fund.start_date,
// //             endDate: fund.end_date,
// //           };
// //         });
// //         setInvestmentsPlans(mapped);
// //       }
// //     } catch (error) {
// //       console.error(error);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
// //         <CircularProgress />
// //       </Box>
// //     );
// //   }

// //   if (selectedProduct) {
// //     return (
// //       <InvestmentDetail
// //         product={selectedProduct}
// //         onBack={() => setSelectedProduct(null)}
// //         userRole={userRole}
// //       />
// //     );
// //   }

// //   const globalFunds = investmentsPlans.filter(
// //   (p) => p.creator?.toLowerCase() === "admin"
// // );
// // const investorSubmissions = investmentsPlans.filter(
// //   (p) => p.creator?.toLowerCase() !== "admin"
// // );

// // const allProducts = tabValue === 0 ? globalFunds : investorSubmissions;

// // //  Use a single derived variable for both display and pagination
// // const activeList = userRole === 'admin' ? allProducts : investmentsPlans;
// // const totalPages = Math.ceil(activeList.length / CARDS_PER_PAGE);
// // const displayProducts = activeList.slice(
// //   (currentPage - 1) * CARDS_PER_PAGE,
// //   currentPage * CARDS_PER_PAGE
// // );

// //   // Slice the current page's worth of cards
// //   // const displayProducts = allProducts.slice(
// //   //   (currentPage - 1) * CARDS_PER_PAGE,
// //   //   currentPage * CARDS_PER_PAGE
// //   // );
// // //   if (userRole === 'admin') {
// // //     displayProducts =  allProducts.slice(
// // //     (currentPage - 1) * CARDS_PER_PAGE,
// // //     currentPage * CARDS_PER_PAGE
// // //   );
// // // } else {
// // //   displayProducts =  investmentsPlans.slice(
// // //     (currentPage - 1) * CARDS_PER_PAGE,
// // //     currentPage * CARDS_PER_PAGE
// // //   );
// // // }

// //   return (
// //     <Box sx={{ p: 4, maxWidth: "1200px", margin: "0 auto" }}>
// //       {/* Header */}
// //       <Box sx={{ display: "flex", alignItems: "center", mb: 4, gap: 2 }}>
// //         <IconButton onClick={onBack} sx={{ bgcolor: "#fff", boxShadow: 1 }}>
// //           <ArrowBackIcon />
// //         </IconButton>
// //         <Box>
// //           <Typography variant="h4" fontWeight="900" color="#002e4c">
// //             {isAdmin ? "Fund Management" : "Investment Marketplace"}
// //           </Typography>
// //           <Typography variant="body2" color="textSecondary">
// //             {isAdmin
// //               ? "Oversee global offerings and investor-submitted funds"
// //               : "Explore and apply for new opportunities"}
// //           </Typography>
// //         </Box>
// //       </Box>

// //       {/* Navigation Tabs for Admin */}
// //       {isAdmin && (
// //         <Tabs
// //   value={tabValue}
// //   onChange={handleTabChange}
// //   sx={{ mb: 4, borderBottom: 1, borderColor: "divider" }}
// // >
// //   <Tab
// //     icon={<BusinessCenterIcon sx={{ fontSize: "1.2rem" }} />}
// //     iconPosition="start"
// //     label={
// //       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
// //         Global Funds
// //         <Chip
// //           label={globalFunds.length}
// //           size="small"
// //           sx={{ bgcolor: "#002e4c", color: "#fff", height: 18, fontSize: "0.7rem" }}
// //         />
// //       </Box>
// //     }
// //   />
// //   <Tab
// //     icon={<PersonIcon sx={{ fontSize: "1.2rem" }} />}
// //     iconPosition="start"
// //     label={
// //       <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
// //         Investor Submissions
// //         <Chip
// //           label={investorSubmissions.length}
// //           size="small"
// //           sx={{ bgcolor: "#002e4c", color: "#fff", height: 18, fontSize: "0.7rem" }}
// //         />
// //       </Box>
// //     }
// //   />
// // </Tabs>
// //       )}

// //       <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
// //         <Typography variant="body2" color="textSecondary">
// //   Showing{" "}
// //   <strong>
// //     {Math.min((currentPage - 1) * CARDS_PER_PAGE + 1, activeList.length)}–
// //     {Math.min(currentPage * CARDS_PER_PAGE, activeList.length)}
// //   </strong>{" "}
// //   of <strong>{activeList.length}</strong> funds
// // </Typography>
// //       </Box>

// //       {/* Cards Grid */}
// //       <Grid container spacing={3}>
// //         {displayProducts.map((product) => (
// //           <Grid item xs={12} md={6} lg={4} key={product.id}>
// //             <Card
// //               sx={{
// //                 height: "100%",
// //                 borderRadius: 3,
// //                 transition: "0.3s",
// //                 "&:hover": { transform: "translateY(-5px)", boxShadow: 6 },
// //               }}
// //             >
// //               <CardContent>
// //                 <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
// //                   {isAdmin && (
// //                     <Typography
// //                       variant="caption"
// //                       sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
// //                     >
// //                       By: <strong>{product.creator}</strong>
// //                     </Typography>
// //                   )}
// //                 </Box>

// //                 <Typography variant="h6" fontWeight="bold" gutterBottom>
// //                   {product.title}
// //                 </Typography>

// //                 {product.description && (
// //                   <Typography
// //                     variant="body2"
// //                     color="textSecondary"
// //                     sx={{
// //                       mb: 1,
// //                       display: "-webkit-box",
// //                       WebkitLineClamp: 2,
// //                       WebkitBoxOrient: "vertical",
// //                       overflow: "hidden",
// //                     }}
// //                   >
// //                     {decodeHtmlEntities(product.description)}
// //                   </Typography>
// //                 )}

// //                 <Divider sx={{ my: 1.5 }} />

// //                 <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
// //                   <Box>
// //                     <Typography variant="caption" color="textSecondary">
// //                       Minimum
// //                     </Typography>
// //                     <Typography variant="body1" fontWeight="bold">
// //                       {product.minEntry}
// //                     </Typography>
// //                   </Box>
// //                   {product.targetYearlyReturn && (
// //                     <Box textAlign="right">
// //                       <Typography variant="caption" color="textSecondary">
// //                         Target Return
// //                       </Typography>
// //                       <Typography variant="body1" fontWeight="bold" color="success.main">
// //                         {product.targetYearlyReturn}
// //                       </Typography>
// //                     </Box>
// //                   )}
// //                 </Box>

// //                 {product.totalFundSize && (
// //                   <Box sx={{ mb: 1 }}>
// //                     <Typography variant="caption" color="textSecondary">
// //                       Fund Size
// //                     </Typography>
// //                     <Typography variant="body2" fontWeight="500">
// //                       {product.totalFundSize}
// //                     </Typography>
// //                   </Box>
// //                 )}
// //               </CardContent>

// //               <Box sx={{ p: 2, pt: 0 }}>
// //                 {isAdmin ? (
// //                   <Box sx={{ display: "flex", gap: 1 }}>
// //                     <Button fullWidth variant="outlined" size="small">
// //                       Edit
// //                     </Button>
// //                     <Button
// //                       fullWidth
// //                       variant="contained"
// //                       size="small"
// //                       color="primary"
// //                       onClick={() => setSelectedProduct(product)}
// //                     >
// //                       View
// //                     </Button>
// //                   </Box>
// //                 ) : (
// //                   <Box sx={{ display: "flex", gap: 1 }}>
// //                     <Button
// //                       fullWidth
// //                       variant="contained"
// //                       onClick={() => handleOpenApply(product)}
// //                       sx={{ bgcolor: "#002e4c", "&:hover": { bgcolor: "#004a7a" } }}
// //                     >
// //                       {userRole === "delegate" ? "Apply for Client" : "Apply Now"}
// //                     </Button>
// //                     <Button
// //                       fullWidth
// //                       variant="contained"
// //                       size="small"
// //                       color="primary"
// //                       onClick={() => setSelectedProduct(product)}
// //                     >
// //                       View
// //                     </Button>
// //                   </Box>
// //                 )}
// //               </Box>
// //             </Card>
// //           </Grid>
// //         ))}
// //       </Grid>

// //       {/* ── Pagination Controls ── */}
// //       {totalPages > 1 && (
// //         <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
// //           <Pagination
// //             count={totalPages}
// //             page={currentPage}
// //             onChange={(_, value) => {
// //               setCurrentPage(value);
// //               window.scrollTo({ top: 0, behavior: "smooth" });
// //             }}
// //             color="primary"
// //             shape="rounded"
// //             showFirstButton
// //             showLastButton
// //             sx={{
// //               "& .MuiPaginationItem-root": {
// //                 fontWeight: 500,
// //               },
// //               "& .Mui-selected": {
// //                 backgroundColor: "#002e4c !important",
// //                 color: "#fff",
// //               },
// //             }}
// //           />
// //         </Box>
// //       )}

// //       <ApplicationModal
// //         open={isApplyModalOpen}
// //         handleClose={handleCloseApply}
// //         product={productToApply}
// //         userRole={userRole}
// //         user={user}
// //       />
// //     </Box>
// //   );
// // };

// // export default InvestmentMarketplace;

// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Grid,
//   Card,
//   CardContent,
//   Tabs,
//   Tab,
//   Chip,
//   IconButton,
//   Avatar,
//   Divider,
//   Badge,
//   CircularProgress,
//   Pagination,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   InputAdornment,
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
// import PersonIcon from "@mui/icons-material/Person";
// import EditIcon from "@mui/icons-material/Edit";
// import InvestmentDetail from "./InvestmentDetail";
// import ApplicationModal from "./ApplicationModal";
// import { commonRunQuery } from "../../util/API/loans";
// import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";

// const CARDS_PER_PAGE = 6;

// const decodeFileName = (name) => {
//   if (!name) return "—";
//   return name
//     .replace(/&amp;#039;/g, "'")
//     .replace(/&amp;#39;/g, "'")
//     .replace(/&#039;/g, "'")
//     .replace(/&#39;/g, "'")
//     .replace(/&amp;/g, "&")
//     .replace(/&lt;/g, "<")
//     .replace(/&gt;/g, ">")
//     .replace(/&quot;/g, '"');
// };

// const InvestmentMarketplace = ({ onBack, userRole }) => {
//   const [tabValue, setTabValue] = useState(0);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
//   const [productToApply, setProductToApply] = useState(null);
//   const [investmentsPlans, setInvestmentsPlans] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // ── Pagination state ──
//   const [currentPage, setCurrentPage] = useState(1);

//   // ── Edit NAV dialog state ──
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [editingProduct, setEditingProduct] = useState(null);
//   const [navInput, setNavInput] = useState("");
//   const [savingNav, setSavingNav] = useState(false);

//   const user = JSON.parse(sessionStorage.getItem("user")).payload?.body;

//   const handleOpenApply = (product) => {
//     setProductToApply(product);
//     setIsApplyModalOpen(true);
//   };

//   const handleCloseApply = () => {
//     setIsApplyModalOpen(false);
//     setProductToApply(null);
//   };

//   // Reset to page 1 whenever tab changes
//   const handleTabChange = (e, val) => {
//     setTabValue(val);
//     setCurrentPage(1);
//   };

//   useEffect(() => {
//     getInvestments();
//   }, []);

//   const isAdmin = userRole === "admin";


//   const getInvestments = async () => {
//     setLoading(true);
//     console.log("Enter the function to get investments");
//     try {
//       const response = await commonRunQuery(359, "");
//       console.log("First Response ????????????", response);

//       const records = response?.data?.body?.record;

//       if (records) {
//         const recordsArray = Array.isArray(records) ? records : [records];
//         const mapped = recordsArray.map((item, index) => {
//           const fund = item.funds;
//           return {
//             id: fund.id,
//             title: decodeFileName(fund.name),
//             minEntry: `$${Number(fund.minimum_ticket_size).toLocaleString()}`,
//             status: "Active",
//             creator: fund.created_by_role,
//             description: fund.description,
//             totalFundSize: `$${Number(fund.total_fund_size).toLocaleString()}`,
//             fundnav: Number(fund.fundnav) || 0, 
//             targetMultiple: fund.target_multiple,
//             targetYearlyReturn: `${fund.target_yearly_return}%`,
//             tvpi: fund.tvpi,
//             dpi: fund.dpi,
//             rvpi: fund.rvpi,
//             videoUrl: fund.associated_video_url,
//             startDate: fund.start_date,
//             endDate: fund.end_date,
//           };
//         });
//         setInvestmentsPlans(mapped);
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOpenEdit = (product) => {
//     setEditingProduct(product);
//     setNavInput(product.fundnav ?? "");
//     setEditDialogOpen(true);
//   };

//   const handleCloseEdit = () => {
//     setEditDialogOpen(false);
//     setEditingProduct(null);
//     setNavInput("");
//   };

//   const handleSaveNav = async () => {
//   if (navInput === "" || isNaN(navInput)) return;
//   setSavingNav(true);
//   try {
//     // TODO: replace with real update call once backend adds NAV support, e.g.
//     // await PortfolioUpdateFundNav(editingProduct.id, navInput);
//     setInvestmentsPlans((prev) =>
//       prev.map((p) =>
//         p.id === editingProduct.id ? { ...p, fundnav: Number(navInput) } : p
//       )
//     );
//     handleCloseEdit();
//   } finally {
//     setSavingNav(false);
//   }
// };

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (selectedProduct) {
//     return (
//       <InvestmentDetail
//         product={selectedProduct}
//         onBack={() => setSelectedProduct(null)}
//         userRole={userRole}
//       />
//     );
//   }

//   const globalFunds = investmentsPlans.filter(
//     (p) => p.creator?.toLowerCase() === "admin"
//   );
//   const investorSubmissions = investmentsPlans.filter(
//     (p) => p.creator?.toLowerCase() !== "admin"
//   );

//   const allProducts = tabValue === 0 ? globalFunds : investorSubmissions;

//   //  Use a single derived variable for both display and pagination
//   const activeList = userRole === "admin" ? allProducts : investmentsPlans;
//   const totalPages = Math.ceil(activeList.length / CARDS_PER_PAGE);
//   const displayProducts = activeList.slice(
//     (currentPage - 1) * CARDS_PER_PAGE,
//     currentPage * CARDS_PER_PAGE
//   );

//   return (
//     <Box sx={{ p: 4, maxWidth: "1200px", margin: "0 auto" }}>
//       {/* Header */}
//       <Box sx={{ display: "flex", alignItems: "center", mb: 4, gap: 2 }}>
//         <IconButton onClick={onBack} sx={{ bgcolor: "#fff", boxShadow: 1 }}>
//           <ArrowBackIcon />
//         </IconButton>
//         <Box>
//           <Typography variant="h4" fontWeight="900" color="#002e4c">
//             {isAdmin ? "Fund Management" : "Investment Marketplace"}
//           </Typography>
//           <Typography variant="body2" color="textSecondary">
//             {isAdmin
//               ? "Oversee global offerings and investor-submitted funds"
//               : "Explore and apply for new opportunities"}
//           </Typography>
//         </Box>
//       </Box>

//       {/* Navigation Tabs for Admin */}
//       {isAdmin && (
//         <Tabs
//           value={tabValue}
//           onChange={handleTabChange}
//           sx={{ mb: 4, borderBottom: 1, borderColor: "divider" }}
//         >
//           <Tab
//             icon={<BusinessCenterIcon sx={{ fontSize: "1.2rem" }} />}
//             iconPosition="start"
//             label={
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                 Global Funds
//                 <Chip
//                   label={globalFunds.length}
//                   size="small"
//                   sx={{ bgcolor: "#002e4c", color: "#fff", height: 18, fontSize: "0.7rem" }}
//                 />
//               </Box>
//             }
//           />
//           <Tab
//             icon={<PersonIcon sx={{ fontSize: "1.2rem" }} />}
//             iconPosition="start"
//             label={
//               <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                 Investor Submissions
//                 <Chip
//                   label={investorSubmissions.length}
//                   size="small"
//                   sx={{ bgcolor: "#002e4c", color: "#fff", height: 18, fontSize: "0.7rem" }}
//                 />
//               </Box>
//             }
//           />
//         </Tabs>
//       )}

//       <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
//         <Typography variant="body2" color="textSecondary">
//           Showing{" "}
//           <strong>
//             {Math.min((currentPage - 1) * CARDS_PER_PAGE + 1, activeList.length)}–
//             {Math.min(currentPage * CARDS_PER_PAGE, activeList.length)}
//           </strong>{" "}
//           of <strong>{activeList.length}</strong> funds
//         </Typography>
//       </Box>

//       {/* Cards Grid */}
//       <Grid container spacing={3}>
//         {displayProducts.map((product) => (
//           <Grid item xs={12} md={6} lg={4} key={product.id}>
//             <Card
//               sx={{
//                 height: "100%",
//                 borderRadius: 3,
//                 transition: "0.3s",
//                 "&:hover": { transform: "translateY(-5px)", boxShadow: 6 },
//               }}
//             >
//               <CardContent>
//                 <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
//                   {isAdmin && (
//                     <Typography
//                       variant="caption"
//                       sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
//                     >
//                       By: <strong>{product.creator}</strong>
//                     </Typography>
//                   )}
//                 </Box>

//                 <Typography variant="h6" fontWeight="bold" gutterBottom>
//                   {product.title}
//                 </Typography>

//                 {product.description && (
//                   <Typography
//                     variant="body2"
//                     color="textSecondary"
//                     sx={{
//                       mb: 1,
//                       display: "-webkit-box",
//                       WebkitLineClamp: 2,
//                       WebkitBoxOrient: "vertical",
//                       overflow: "hidden",
//                     }}
//                   >
//                     {decodeHtmlEntities(product.description)}
//                   </Typography>
//                 )}

//                 <Divider sx={{ my: 1.5 }} />

//                 <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
//                   <Box>
//                     <Typography variant="caption" color="textSecondary">
//                       Minimum
//                     </Typography>
//                     <Typography variant="body1" fontWeight="bold">
//                       {product.minEntry}
//                     </Typography>
//                   </Box>
//                   {product.targetYearlyReturn && (
//                     <Box textAlign="right">
//                       <Typography variant="caption" color="textSecondary">
//                         Target Return
//                       </Typography>
//                       <Typography variant="body1" fontWeight="bold" color="success.main">
//                         {product.targetYearlyReturn}
//                       </Typography>
//                     </Box>
//                   )}
//                 </Box>

//                 <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
//                   <Box>
//                     <Typography variant="caption" color="textSecondary">
//                       NAV
//                     </Typography>
//                     <Typography variant="body1" fontWeight="bold" color="#002e4c">
//                       ${Number(product.fundnav || 0).toLocaleString()}
//                     </Typography>
//                   </Box>
//                 </Box>

//                 {product.totalFundSize && (
//                   <Box sx={{ mb: 1 }}>
//                     <Typography variant="caption" color="textSecondary">
//                       Fund Size
//                     </Typography>
//                     <Typography variant="body2" fontWeight="500">
//                       {product.totalFundSize}
//                     </Typography>
//                   </Box>
//                 )}
//               </CardContent>

//               <Box sx={{ p: 2, pt: 0 }}>
//                 {isAdmin ? (
//                   <Box sx={{ display: "flex", gap: 1 }}>
//                     <Button
//                       fullWidth
//                       variant="outlined"
//                       size="small"
//                       startIcon={<EditIcon fontSize="small" />}
//                       onClick={() => handleOpenEdit(product)}
//                     >
//                       Edit NAV
//                     </Button>
//                     <Button
//                       fullWidth
//                       variant="contained"
//                       size="small"
//                       color="primary"
//                       onClick={() => setSelectedProduct(product)}
//                     >
//                       View
//                     </Button>
//                   </Box>
//                 ) : (
//                   <Box sx={{ display: "flex", gap: 1 }}>
//                     <Button
//                       fullWidth
//                       variant="contained"
//                       onClick={() => handleOpenApply(product)}
//                       sx={{ bgcolor: "#002e4c", "&:hover": { bgcolor: "#004a7a" } }}
//                     >
//                       {userRole === "delegate" ? "Apply for Client" : "Apply Now"}
//                     </Button>
//                     <Button
//                       fullWidth
//                       variant="contained"
//                       size="small"
//                       color="primary"
//                       onClick={() => setSelectedProduct(product)}
//                     >
//                       View
//                     </Button>
//                   </Box>
//                 )}
//               </Box>
//             </Card>
//           </Grid>
//         ))}
//       </Grid>

//       {/* ── Pagination Controls ── */}
//       {totalPages > 1 && (
//         <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
//           <Pagination
//             count={totalPages}
//             page={currentPage}
//             onChange={(_, value) => {
//               setCurrentPage(value);
//               window.scrollTo({ top: 0, behavior: "smooth" });
//             }}
//             color="primary"
//             shape="rounded"
//             showFirstButton
//             showLastButton
//             sx={{
//               "& .MuiPaginationItem-root": {
//                 fontWeight: 500,
//               },
//               "& .Mui-selected": {
//                 backgroundColor: "#002e4c !important",
//                 color: "#fff",
//               },
//             }}
//           />
//         </Box>
//       )}

//       <ApplicationModal
//         open={isApplyModalOpen}
//         handleClose={handleCloseApply}
//         product={productToApply}
//         userRole={userRole}
//         user={user}
//       />

//       {/* ── Edit NAV Dialog ── */}
//       <Dialog open={editDialogOpen} onClose={handleCloseEdit} maxWidth="xs" fullWidth>
//         <DialogTitle sx={{ fontWeight: "bold" }}>
//           Update NAV
//           <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "normal", mt: 0.5 }}>
//             {editingProduct?.title}
//           </Typography>
//         </DialogTitle>
//         <DialogContent>
//           <TextField
//             autoFocus
//             fullWidth
//             label="Net Asset Value"
//             type="number"
//             value={navInput}
//             onChange={(e) => setNavInput(e.target.value)}
//             sx={{ mt: 1 }}
//             InputProps={{
//               startAdornment: <InputAdornment position="start">$</InputAdornment>,
//             }}
//           />
//         </DialogContent>
//         <DialogActions sx={{ px: 3, pb: 2 }}>
//           <Button onClick={handleCloseEdit} disabled={savingNav}>
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleSaveNav}
//             disabled={savingNav || navInput === ""}
//             sx={{ bgcolor: "#002e4c", "&:hover": { bgcolor: "#004a7a" } }}
//           >
//             {savingNav ? <CircularProgress size={18} color="inherit" /> : "Save"}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default InvestmentMarketplace;

import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardContent,
  Tabs,
  Tab,
  Chip,
  IconButton,
  Avatar,
  Divider,
  Badge,
  CircularProgress,
  Pagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Stack,
  LinearProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import PersonIcon from "@mui/icons-material/Person";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import LockIcon from "@mui/icons-material/Lock";
import DeleteIcon from "@mui/icons-material/Delete";
import InvestmentDetail from "./InvestmentDetail";
import ApplicationModal from "./ApplicationModal";
import { commonRunQuery } from "../../util/API/loans";
import { decodeHtmlEntities } from "../../util/utilfunctions/utilFunctions";

const CARDS_PER_PAGE = 6;

const decodeFileName = (name) => {
  if (!name) return "—";
  return name
    .replace(/&amp;#039;/g, "'")
    .replace(/&amp;#39;/g, "'")
    .replace(/&#039;/g, "'")
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"');
};

// ── Dummy multi-close data, keyed by fund id. Replace with real fetch
// (e.g. commonRunQuery against a new `fund_closes` table) once Nandakumar
// exposes it. Falls back to a single default close if a fund has none. ──
const DUMMY_CLOSES_BY_FUND = {};
const defaultClosesForFund = (fundId) =>
  DUMMY_CLOSES_BY_FUND[fundId] || [
    { id: `${fundId}-1`, closeNumber: 1, amount: 1500000, date: "2026-03-15", status: "finalized" },
    { id: `${fundId}-2`, closeNumber: 2, amount: 900000, date: "2026-06-30", status: "active" },
  ];

const closeStatusColor = {
  finalized: "default",
  active: "success",
  pending: "warning",
};

// ── Dummy investor holdings, keyed by fund id. Replace with real fetch
// against `investor_fund_holdings` once available. ──
const DUMMY_HOLDINGS_BY_FUND = {};
const defaultHoldingsForFund = () =>
  DUMMY_HOLDINGS_BY_FUND[0] || [
    { id: 1, investor: "Bally Crystal", units: 3966 },
    { id: 2, investor: "Holdun Opportunity Fund", units: 12160 },
    { id: 3, investor: "4303903 Canada Ltd.", units: 8420 },
    { id: 4, investor: "Holdun Investments Inc.", units: 5100 },
    { id: 5, investor: "Holdun Family Office Canada Inc.", units: 3040 },
  ];

const InvestmentMarketplace = ({ onBack, userRole }) => {
  const [tabValue, setTabValue] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [productToApply, setProductToApply] = useState(null);
  const [investmentsPlans, setInvestmentsPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  // ── Pagination state ──
  const [currentPage, setCurrentPage] = useState(1);

  // ── Edit NAV dialog state ──
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [navInput, setNavInput] = useState("");
  const [savingNav, setSavingNav] = useState(false);

  // ── Edit dialog sub-section: nav | closes | holdings ──
  const [editSection, setEditSection] = useState("nav");

  // ── Closes state, per-fund, seeded with dummy data on open ──
  const [closes, setCloses] = useState([]);
  const [newCloseAmount, setNewCloseAmount] = useState("");
  const [newCloseDate, setNewCloseDate] = useState("");

  const user = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  const handleOpenApply = (product) => {
    setProductToApply(product);
    setIsApplyModalOpen(true);
  };

  const handleCloseApply = () => {
    setIsApplyModalOpen(false);
    setProductToApply(null);
  };

  // Reset to page 1 whenever tab changes
  const handleTabChange = (e, val) => {
    setTabValue(val);
    setCurrentPage(1);
  };

  useEffect(() => {
    getInvestments();
  }, []);

  const isAdmin = userRole === "admin";


  const getInvestments = async () => {
    setLoading(true);
    console.log("Enter the function to get investments");
    try {
      const response = await commonRunQuery(359, "");
      console.log("First Response ????????????", response);

      const records = response?.data?.body?.record;

      if (records) {
        const recordsArray = Array.isArray(records) ? records : [records];
        const mapped = recordsArray.map((item, index) => {
          const fund = item.funds;
          return {
            id: fund.id,
            title: decodeFileName(fund.name),
            minEntry: `$${Number(fund.minimum_ticket_size).toLocaleString()}`,
            status: "Active",
            creator: fund.created_by_role,
            description: fund.description,
            totalFundSize: `$${Number(fund.total_fund_size).toLocaleString()}`,
            fundnav: Number(fund.fundnav) || 0, 
            targetMultiple: fund.target_multiple,
            targetYearlyReturn: `${fund.target_yearly_return}%`,
            tvpi: fund.tvpi,
            dpi: fund.dpi,
            rvpi: fund.rvpi,
            videoUrl: fund.associated_video_url,
            startDate: fund.start_date,
            endDate: fund.end_date,
          };
        });
        setInvestmentsPlans(mapped);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenEdit = (product) => {
    setEditingProduct(product);
    setNavInput(product.fundnav ?? "");
    setCloses(defaultClosesForFund(product.id));
    setEditSection("nav");
    setEditDialogOpen(true);
  };

  const handleCloseEdit = () => {
    setEditDialogOpen(false);
    setEditingProduct(null);
    setNavInput("");
    setCloses([]);
    setNewCloseAmount("");
    setNewCloseDate("");
    setEditSection("nav");
  };

  const handleSaveNav = async () => {
    if (navInput === "" || isNaN(navInput)) return;
    setSavingNav(true);
    try {
      // TODO: replace with real update call once backend adds NAV support, e.g.
      // await PortfolioUpdateFundNav(editingProduct.id, navInput);
      setInvestmentsPlans((prev) =>
        prev.map((p) =>
          p.id === editingProduct.id ? { ...p, fundnav: Number(navInput) } : p
        )
      );
      handleCloseEdit();
    } finally {
      setSavingNav(false);
    }
  };

  // ── Closes handlers (dummy, local state only — see fund_closes note above) ──
  const addClose = () => {
    if (!newCloseAmount || !newCloseDate) return;
    setCloses((prev) => [
      ...prev,
      {
        id: `${editingProduct?.id}-${Date.now()}`,
        closeNumber: prev.length + 1,
        amount: Number(newCloseAmount),
        date: newCloseDate,
        status: "pending",
      },
    ]);
    setNewCloseAmount("");
    setNewCloseDate("");
  };

  const removeClose = (id) =>
    setCloses((prev) => prev.filter((c) => c.id !== id));

  const triggerClose = (id) => {
    // TODO: once backend exists, this should call something like
    // PortfolioTriggerClose(editingProduct.id, closeId) which locks the
    // close_date server-side as the anchor for NAV/return calculations.
    setCloses((prev) =>
      prev.map((c) => (c.id === id ? { ...c, status: "active" } : c))
    );
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (selectedProduct) {
    return (
      <InvestmentDetail
        product={selectedProduct}
        onBack={() => setSelectedProduct(null)}
        userRole={userRole}
      />
    );
  }

  const globalFunds = investmentsPlans.filter(
    (p) => p.creator?.toLowerCase() === "admin"
  );
  const investorSubmissions = investmentsPlans.filter(
    (p) => p.creator?.toLowerCase() !== "admin"
  );

  const allProducts = tabValue === 0 ? globalFunds : investorSubmissions;

  //  Use a single derived variable for both display and pagination
  const activeList = userRole === "admin" ? allProducts : investmentsPlans;
  const totalPages = Math.ceil(activeList.length / CARDS_PER_PAGE);
  const displayProducts = activeList.slice(
    (currentPage - 1) * CARDS_PER_PAGE,
    currentPage * CARDS_PER_PAGE
  );

  // Derived holdings/NAV-per-unit for the currently edited fund
  const holdings = defaultHoldingsForFund();
  const totalUnits = holdings.reduce((sum, h) => sum + h.units, 0);
  const currentNavForCalc = editingProduct?.fundnav || 0;
  const navPerUnit = totalUnits > 0 ? currentNavForCalc / totalUnits : 0;

  return (
    <Box sx={{ p: 4, maxWidth: "1200px", margin: "0 auto" }}>
      {/* Header */}
      <Box sx={{ display: "flex", alignItems: "center", mb: 4, gap: 2 }}>
        <IconButton onClick={onBack} sx={{ bgcolor: "#fff", boxShadow: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" fontWeight="900" color="#002e4c">
            {isAdmin ? "Fund Management" : "Investment Marketplace"}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {isAdmin
              ? "Oversee global offerings and investor-submitted funds"
              : "Explore and apply for new opportunities"}
          </Typography>
        </Box>
      </Box>

      {/* Navigation Tabs for Admin */}
      {isAdmin && (
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          sx={{ mb: 4, borderBottom: 1, borderColor: "divider" }}
        >
          <Tab
            icon={<BusinessCenterIcon sx={{ fontSize: "1.2rem" }} />}
            iconPosition="start"
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                Global Funds
                <Chip
                  label={globalFunds.length}
                  size="small"
                  sx={{ bgcolor: "#002e4c", color: "#fff", height: 18, fontSize: "0.7rem" }}
                />
              </Box>
            }
          />
          <Tab
            icon={<PersonIcon sx={{ fontSize: "1.2rem" }} />}
            iconPosition="start"
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                Investor Submissions
                <Chip
                  label={investorSubmissions.length}
                  size="small"
                  sx={{ bgcolor: "#002e4c", color: "#fff", height: 18, fontSize: "0.7rem" }}
                />
              </Box>
            }
          />
        </Tabs>
      )}

      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="body2" color="textSecondary">
          Showing{" "}
          <strong>
            {Math.min((currentPage - 1) * CARDS_PER_PAGE + 1, activeList.length)}–
            {Math.min(currentPage * CARDS_PER_PAGE, activeList.length)}
          </strong>{" "}
          of <strong>{activeList.length}</strong> funds
        </Typography>
      </Box>

      {/* Cards Grid */}
      <Grid container spacing={3}>
        {displayProducts.map((product) => (
          <Grid item xs={12} md={6} lg={4} key={product.id}>
            <Card
              sx={{
                height: "100%",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-5px)", boxShadow: 6 },
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                  {isAdmin && (
                    <Typography
                      variant="caption"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      By: <strong>{product.creator}</strong>
                    </Typography>
                  )}
                </Box>

                <Typography variant="h6" fontWeight="bold" gutterBottom>
                  {product.title}
                </Typography>

                {product.description && (
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{
                      mb: 1,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {decodeHtmlEntities(product.description)}
                  </Typography>
                )}

                <Divider sx={{ my: 1.5 }} />

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Box>
                    <Typography variant="caption" color="textSecondary">
                      Minimum
                    </Typography>
                    <Typography variant="body1" fontWeight="bold">
                      {product.minEntry}
                    </Typography>
                  </Box>
                  {product.targetYearlyReturn && (
                    <Box textAlign="right">
                      <Typography variant="caption" color="textSecondary">
                        Target Return
                      </Typography>
                      <Typography variant="body1" fontWeight="bold" color="success.main">
                        {product.targetYearlyReturn}
                      </Typography>
                    </Box>
                  )}
                </Box>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Box>
                    <Typography variant="caption" color="textSecondary">
                      NAV
                    </Typography>
                    <Typography variant="body1" fontWeight="bold" color="#002e4c">
                      ${Number(product.fundnav || 0).toLocaleString()}
                    </Typography>
                  </Box>
                </Box>

                {product.totalFundSize && (
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="textSecondary">
                      Fund Size
                    </Typography>
                    <Typography variant="body2" fontWeight="500">
                      {product.totalFundSize}
                    </Typography>
                  </Box>
                )}
              </CardContent>

              <Box sx={{ p: 2, pt: 0 }}>
                {isAdmin ? (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      startIcon={<EditIcon fontSize="small" />}
                      onClick={() => handleOpenEdit(product)}
                    >
                      Manage
                    </Button>
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={() => setSelectedProduct(product)}
                    >
                      View
                    </Button>
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() => handleOpenApply(product)}
                      sx={{ bgcolor: "#002e4c", "&:hover": { bgcolor: "#004a7a" } }}
                    >
                      {userRole === "delegate" ? "Apply for Client" : "Apply Now"}
                    </Button>
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      color="primary"
                      onClick={() => setSelectedProduct(product)}
                    >
                      View
                    </Button>
                  </Box>
                )}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* ── Pagination Controls ── */}
      {totalPages > 1 && (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ mt: 4 }}>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={(_, value) => {
              setCurrentPage(value);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            color="primary"
            shape="rounded"
            showFirstButton
            showLastButton
            sx={{
              "& .MuiPaginationItem-root": {
                fontWeight: 500,
              },
              "& .Mui-selected": {
                backgroundColor: "#002e4c !important",
                color: "#fff",
              },
            }}
          />
        </Box>
      )}

      <ApplicationModal
        open={isApplyModalOpen}
        handleClose={handleCloseApply}
        product={productToApply}
        userRole={userRole}
        user={user}
      />

      {/* ── Manage Fund Dialog: NAV / Closes / Holdings ── */}
      <Dialog open={editDialogOpen} onClose={handleCloseEdit} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: "bold" }}>
          Manage Fund
          <Typography variant="body2" color="textSecondary" sx={{ fontWeight: "normal", mt: 0.5 }}>
            {editingProduct?.title}
          </Typography>
        </DialogTitle>

        <Tabs
          value={editSection}
          onChange={(e, val) => setEditSection(val)}
          sx={{ px: 3, borderBottom: 1, borderColor: "divider" }}
        >
          <Tab value="nav" label="NAV" sx={{ minHeight: 40 }} />
          <Tab value="closes" label="Closes" sx={{ minHeight: 40 }} />
          <Tab value="holdings" label="Investor Holdings" sx={{ minHeight: 40 }} />
        </Tabs>

        <DialogContent>
          {/* ── NAV section ── */}
          {editSection === "nav" && (
            <TextField
              autoFocus
              fullWidth
              label="Net Asset Value"
              type="number"
              value={navInput}
              onChange={(e) => setNavInput(e.target.value)}
              sx={{ mt: 2 }}
              InputProps={{
                startAdornment: <InputAdornment position="start">$</InputAdornment>,
              }}
            />
          )}

          {/* ── Closes section ── */}
          {editSection === "closes" && (
            <Box sx={{ mt: 1 }}>
              <Typography variant="caption" color="textSecondary" display="block" mb={2}>
                Add one or more closes. Triggering a close locks its date as the
                anchor for NAV and return calculations from that point forward.
              </Typography>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Close Date</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell align="right">Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {closes.map((c) => (
                    <TableRow key={c.id}>
                      <TableCell>{c.closeNumber}</TableCell>
                      <TableCell>${c.amount.toLocaleString()}</TableCell>
                      <TableCell>{c.date}</TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={c.status}
                          color={closeStatusColor[c.status]}
                          variant={c.status === "active" ? "filled" : "outlined"}
                        />
                      </TableCell>
                      <TableCell align="right">
                        {c.status === "pending" ? (
                          <Button
                            size="small"
                            startIcon={<LockIcon fontSize="inherit" />}
                            onClick={() => triggerClose(c.id)}
                          >
                            Trigger
                          </Button>
                        ) : (
                          <IconButton
                            size="small"
                            onClick={() => removeClose(c.id)}
                            disabled={c.status !== "pending"}
                          >
                            <DeleteIcon fontSize="inherit" sx={{ opacity: 0.3 }} />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              <Divider sx={{ my: 2 }} />

              <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
                <TextField
                  label="Amount ($)"
                  type="number"
                  size="small"
                  value={newCloseAmount}
                  onChange={(e) => setNewCloseAmount(e.target.value)}
                  sx={{ width: 140 }}
                />
                <TextField
                  label="Close Date"
                  type="date"
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={newCloseDate}
                  onChange={(e) => setNewCloseDate(e.target.value)}
                  sx={{ width: 160 }}
                />
                <Button variant="outlined" startIcon={<AddIcon />} onClick={addClose}>
                  Add Close
                </Button>
              </Stack>
            </Box>
          )}

          {/* ── Investor Holdings section ── */}
          {editSection === "holdings" && (
            <Box sx={{ mt: 1 }}>
              <Stack direction="row" justifyContent="space-between" alignItems="baseline" mb={0.5}>
                <Typography variant="caption" color="textSecondary">
                  % of fund = investor's units ÷ total units outstanding. Value =
                  units × NAV per unit.
                </Typography>
                <Typography variant="caption" color="textSecondary" whiteSpace="nowrap">
                  NAV/unit: ${navPerUnit.toFixed(2)}
                </Typography>
              </Stack>

              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Investor / Entity</TableCell>
                    <TableCell align="right">Units</TableCell>
                    <TableCell align="right">% of Fund</TableCell>
                    <TableCell align="right">Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {holdings.map((h) => {
                    const pct = totalUnits > 0 ? (h.units / totalUnits) * 100 : 0;
                    const value = h.units * navPerUnit;
                    return (
                      <TableRow key={h.id}>
                        <TableCell>{h.investor}</TableCell>
                        <TableCell align="right">{h.units.toLocaleString()}</TableCell>
                        <TableCell align="right">
                          <Stack direction="row" alignItems="center" spacing={1} justifyContent="flex-end">
                            <Box sx={{ width: 50 }}>
                              <LinearProgress
                                variant="determinate"
                                value={pct}
                                sx={{ height: 5, borderRadius: 5 }}
                              />
                            </Box>
                            <Typography variant="body2">{pct.toFixed(1)}%</Typography>
                          </Stack>
                        </TableCell>
                        <TableCell align="right">
                          <Typography fontWeight="bold">
                            ${value.toLocaleString(undefined, { maximumFractionDigits: 0 })}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseEdit} disabled={savingNav}>
            Cancel
          </Button>
          {editSection === "nav" && (
            <Button
              variant="contained"
              onClick={handleSaveNav}
              disabled={savingNav || navInput === ""}
              sx={{ bgcolor: "#002e4c", "&:hover": { bgcolor: "#004a7a" } }}
            >
              {savingNav ? <CircularProgress size={18} color="inherit" /> : "Save"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default InvestmentMarketplace;